import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEocTabIVB as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEocTabIVB = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  const completeFafsaField = () => {
    const propertyName = pn<AprResponseModel>("completeFafsa");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.completeFafsa}{" "}
        {formatPercentTotal(props.data?.completeFafsa, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const incompleteFafsaField = () => {
    const propertyName = pn<AprResponseModel>("incompleteFafsa");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.incompleteFafsa}{" "}
        {formatPercentTotal(props.data?.incompleteFafsa, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const unknown4BField = () => {
    const propertyName = pn<AprResponseModel>("unknown4B");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <DataDisplay label={property?.displayName}>
        {props.data?.unknown4B} {formatPercentTotal(props.data?.unknown4B, props.data?.totalParticipants)}
      </DataDisplay>
    );
  };

  const totalParticipantsField = () => {
    const propertyName = pn<AprResponseModel>("totalParticipants");
    const property = props.properties?.find((x) => x.propertyName === propertyName);

    return (
      <Stack direction="column">
        <DataDisplay label={property?.displayName}>{props.data?.totalParticipants}</DataDisplay>
      </Stack>
    );
  };

  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" style={{ height: "100%" }}>
        <Typography variant="h5">Financial Aid Applications</Typography>
        <Grid container spacing="lg">
          <Grid item xs={11}>
            <Grid container spacing="lg">
              {props.data?.completeFafsa != null && (
                <Grid item xs={12}>
                  {completeFafsaField()}
                </Grid>
              )}
              <GridBreak />

              {props.data?.incompleteFafsa != null && (
                <Grid item xs={12}>
                  {incompleteFafsaField()}
                </Grid>
              )}

              {props.data?.unknown4B != null && (
                <Grid item xs={12}>
                  {unknown4BField()}
                </Grid>
              )}

              <Grid item xs={12}>
                {totalParticipantsField()}
              </Grid>
              <GridBreak />
            </Grid>
          </Grid>

          <GridBreak />

          {/* <Grid item xs={6}>
            <PieChart
              id="pie-tab-a"
              dataSource={props.data?.chartValues}
              palette="Bright"
              title="Participants"
              width="100%"
            >
              <Series argumentField="label" valueField="value">
                <Label visible={true}>
                  <Connector visible={true} width={1} />
                </Label>
              </Series>
            </PieChart>
          </Grid> */}
        </Grid>
      </Stack>
    </Card>
  );
};
